"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(splitAtTopLevelOnly);

require("core-js/modules/esnext.string.match-all.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.splitAtTopLevelOnly = splitAtTopLevelOnly;

var regex = _interopRequireWildcard(require("../lib/regex"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function splitAtTopLevelOnly(input, separator) {
  var SPECIALS, depth, lastIndex, found, separatorIndex, separatorStart, separatorLength, _iterator, _step, match, matchesSeparator, atEndOfSeparator, matchesFullSeparator;

  return _regeneratorRuntime.wrap(function splitAtTopLevelOnly$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          SPECIALS = new RegExp("[(){}\\[\\]".concat(regex.escape(separator), "]"), "g");
          depth = 0;
          lastIndex = 0;
          found = false;
          separatorIndex = 0;
          separatorStart = 0;
          separatorLength = separator.length; // Find all paren-like things & character
          // And only split on commas if they're top-level

          _iterator = _createForOfIteratorHelper(input.matchAll(SPECIALS));
          _context.prev = 8;

          _iterator.s();

        case 10:
          if ((_step = _iterator.n()).done) {
            _context.next = 30;
            break;
          }

          match = _step.value;
          matchesSeparator = match[0] === separator[separatorIndex];
          atEndOfSeparator = separatorIndex === separatorLength - 1;
          matchesFullSeparator = matchesSeparator && atEndOfSeparator;
          if (match[0] === "(") depth++;
          if (match[0] === ")") depth--;
          if (match[0] === "[") depth++;
          if (match[0] === "]") depth--;
          if (match[0] === "{") depth++;
          if (match[0] === "}") depth--;

          if (matchesSeparator && depth === 0) {
            if (separatorStart === 0) {
              separatorStart = match.index;
            }

            separatorIndex++;
          }

          if (!(matchesFullSeparator && depth === 0)) {
            _context.next = 27;
            break;
          }

          found = true;
          _context.next = 26;
          return input.substring(lastIndex, separatorStart);

        case 26:
          lastIndex = separatorStart + separatorLength;

        case 27:
          if (separatorIndex === separatorLength) {
            separatorIndex = 0;
            separatorStart = 0;
          }

        case 28:
          _context.next = 10;
          break;

        case 30:
          _context.next = 35;
          break;

        case 32:
          _context.prev = 32;
          _context.t0 = _context["catch"](8);

          _iterator.e(_context.t0);

        case 35:
          _context.prev = 35;

          _iterator.f();

          return _context.finish(35);

        case 38:
          if (!found) {
            _context.next = 43;
            break;
          }

          _context.next = 41;
          return input.substring(lastIndex);

        case 41:
          _context.next = 45;
          break;

        case 43:
          _context.next = 45;
          return input;

        case 45:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[8, 32, 35, 38]]);
}